import SecurityColumn from "components/Auth/SecurityColumn";
import { Col, ElementWrapper, Row } from "components/BaseComponents/Flex";
import { Container, Login } from "components";
import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setClientUID } from "redux/slices/LoginSlice";

const LoginScreen = () => {
  const dispatch = useAppDispatch();

  const { clientUID } = useAppSelector((state) => state.login);

  useEffect(() => {
    if (!clientUID) {
      const rndInt = Math.floor(Math.random() * (9999999999999999 - 0 + 1)) + 0;
      dispatch(setClientUID(rndInt.toString()));
    }
  }, [dispatch, clientUID]);

  return (
    <Container>
      <ElementWrapper
        minHeight='calc(100vh - 137px)'
        padding='48px 0 0 0'
        width='872px'
      >
        <>
          <Login />

          <Row
            alignItems='flex-start'
            backgroundColor={DIGIPOSTHEME.colors.secondaryOffWhite}
            justifyContent='center'
            isResponsive
            noMargin
          >
            <Col>
              <SecurityColumn />
            </Col>
          </Row>
        </>
      </ElementWrapper>
    </Container>
  );
};

export default LoginScreen;
